<template>
  <div class="form-wrapper">
    <h2>Add Assignment Attempt</h2>
    <form
      class="add-user-to-cohort px-5"
      @submit.prevent="updateUserCohortPath"
    >
      <label for="user-id">User ID</label>
      <input
        id="user-id"
        v-model="userID"
        class="border"
        autofocus
        placeholder="Enter user id or email"
        required
        type="text"
      />
      <div class="mt-3">
        <VueSelect
          placeholder="Select Cohort"
          :options="cohortList"
          label="name"
          :reduce="cohort => cohort.name"
          @input="selectCohort"
        />
      </div>
      <div v-if="cohortID" class="mt-3">
        <VueSelect
          placeholder="Select Assignment"
          :options="assignments"
          label="name"
          :reduce="assignment => assignment.name"
          @input="selectAssignment"
        />
      </div>

      <label v-if="selectedAssignment !== undefined" for="assignment-id"
        >Attempts left</label
      >
      <input
        v-if="selectedAssignment !== undefined"
        v-model.number="selectedAssignment.attempts_left"
        type="number"
      />
      <button
        v-if="selectedAssignment !== undefined"
        class="button-green link border p-3 px-12 rounded-full bg-green text-white font-bold m-1"
        type="submit"
      >
        Add attempt
      </button>
    </form>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueSelect },
  data() {
    return {
      userID: undefined,
      cohortList: [],
      cohortID: undefined,
      userCohortpath: undefined,
      assignments: [],
      selectedAssignment: undefined,
      selectedCohort: {},
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}cohorts/?pagination=false`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      this.cohortList = res.data.items
    })
  },
  methods: {
    fetchUserCohortPath() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/user_cohort/${this.userID}/${this.cohortID}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.userCohortpath = res.data
        this.assignments = this.userCohortpath.modules.map(
          (moduleObj, index) => {
            if (moduleObj.assignment) {
              return {
                module_index: index,
                attempts_done:
                  moduleObj.assignment.assignment_status.num_attempts_done,
                attempts_left:
                  moduleObj.assignment.assignment_status.num_attempts_left,
                name: moduleObj.assignment.name,
              }
            }
            return undefined
          }
        )
        this.assignments = this.assignments.filter(
          assignmentObj => !!assignmentObj
        )
      })
    },
    updateUserCohortPath() {
      this.axios({
        method: "patch",
        url: `${siteConfig.siteURL}admin/user_cohort/${this.userID}/${this.cohortID}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: this.selectedAssignment,
      })
        .then(() => {
          this.$noty.success("Successfully updated assignment attempts!")
        })
        .catch(() => {
          this.$noty.error("failed to  update assignment attempts")
        })
    },
    selectCohort(selectedCohort) {
      if (selectedCohort) {
        this.cohortID = selectedCohort.id
        this.fetchUserCohortPath()
      } else {
        this.cohortID = undefined
        this.selectedAssignment = undefined
        this.assignments = []
      }
    },
    selectAssignment(assignment) {
      this.selectedAssignment = assignment || undefined
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input,
textarea,
select {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border: 1px solid lightgray;
  border-radius: 4px;
  background-color: #fff;
  font-size: 16px;
  /* text-align: center; */
}
textarea {
  height: 150px;
}
input {
  height: 34px;
}
label {
  display: block;
  padding: 10px 20px;
  font-size: 16px;
  text-align: left;
}
</style>
